import { Attributes, LookupBase } from '@singularsystems/neo-core';

export default class ParticipantRulesConfigLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public readonly enableBeneficiaries: boolean = false;

    @Attributes.Integer()
    public readonly maximumNumberOfBeneficiaries: number = 0;

    public readonly enableCommunicationPreferences: boolean = false;

    // Client only properties / methods
}